import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { paymentMethodSignupStepUrl } from '@well/navigation';

@Component({
  selector: 'signup-choose-subscription',
  templateUrl: './choose-subscription.component.html',
  styleUrls: ['./choose-subscription.component.scss'],
})
export class ChooseSubscriptionComponent implements OnInit {

  legalEntityUuid: string | undefined = undefined;

  constructor(private route: ActivatedRoute,
              private router: Router) {}

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.legalEntityUuid = params['legalEntityUuid'];
    })
  }

  onSubscriptionSaved(event: any){
    this.router.navigate(paymentMethodSignupStepUrl(this.legalEntityUuid, event));
  }

}
